fragment DripProgressionEditionsFragment on DripProgressionEdition {
    sent
    edition {
        id
        name
        htmlUrl
        status
        scheduledTime
        emailTemplate {
            id
        }
        delay {
            unit
            timespan
        }
    }
}
